import { Injectable } from '@angular/core';
import { Feature } from '../models/feature';
import { Observable } from 'rxjs';
import { Http, Response, Headers, RequestOptions } from '@angular/http';
import { RouterModule, Routes, Router } from '@angular/router';
//import { AppRoutingModule } from '../modules/app-routing.module';  

@Injectable()
export class FeatureService { 

  constructor(private _http: Http) { }

  GetFeatures(): Observable<Array<Feature>> {    
    return this._http.get('/api/feature')
      .map(this.extractData)
      .catch(this.handleError);
  }
 
  GetFeature(id: number): Observable<Feature> {    
   return this._http.get('/api/feature/' + id)
     .map(this.extractData)
     .catch(this.handleError);
 }

 private extractData(res: Response) {
  let data
  if (res.text()) {
    data = res.json();
  }
  return data || {};
}

private handleError(error: Response | any) {
  // In a real world app, we might use a remote logging infrastructure
  let errMsg: string;
  if (error instanceof Response) {
    const body = error.json() || '';
    const err = body.error || JSON.stringify(body);
    errMsg = `${error.status} - ${error.statusText || ''} ${err}`;
  } else {
    errMsg = error.message ? error.message : error.toString();
  }
  console.error(errMsg);
  return Observable.throw(errMsg);
}

Save(item: Feature): Observable<Feature> {    
  return this._http.put('/api/feature', item)
    .map(this.extractData)
    .catch(this.handleError);
}

Create(item: Feature): Observable<Feature> {    
  return this._http.post('/api/feature', item)
    .map(this.extractData)
    .catch(this.handleError);
}

Delete(item: Feature): Observable<Feature> {    
  return this._http.delete('/api/feature/' + item.FeatureId)
    .map(this.extractData)
    .catch(this.handleError);
}

}



// WEBPACK FOOTER //
// ./src/app/services/feature.service.ts